import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useMutation } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import useLoadingAdditionalInformation from 'hooks/Shared/useLoadingAdditionalInformation'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { MutationOptions } from 'models/general'
import { IInvoice } from 'models/invoices.models'
import { sendCfdiByEmail } from 'services/Invoices/invoices.services'

const useSendInvoiceByEmail = (
  workspaceId: number,
  options: MutationOptions<void, IInvoice> = {}
) => {
  const { onSuccess, onError, noDialog } = options

  const dialog = useDialog()
  const showAdditionalInformationLoading = useLoadingAdditionalInformation()

  const mutation = useMutation<void, any, IInvoice>(
    invoice => {
      if (!invoice || !invoice.idCfdi) throw new Error('CFDI cargado incorrectamente')
      return sendCfdiByEmail(workspaceId, invoice.idCfdi)
    },
    {
      onMutate: () => {
        showAdditionalInformationLoading()
      },
      onSuccess: (data, invoice, ctx) => {
        dialog.close()
        setTimeout(() => {
          onSuccess && onSuccess(data, invoice, ctx)
        }, 350)
      },
      onError: async (error, invoice, ctx) => {
        setTimeout(async () => {
          const op = selectErrorDialog(error)

          if (op?.variant) {
            await dialog[op.variant](op)
            return
          }

          if (!noDialog) {
            const rp = await dialog.dangerAsync({
              title: 'generic.error.title',
              subtitle:
                'No se pudo enviar el CFDI seleccionado. Intenta nuevamente.',
              icon: ErrorOutline as TModalIcon,
              primaryButtonText: 'Reintentar',
              secondaryButtonText: 'Cancelar',
            })

            if (rp) {
              mutation.mutate(invoice)
              return
            }
          }

          onError && onError(error, invoice, ctx)
        }, 600)
      },
    }
  )

  return mutation
}

export default useSendInvoiceByEmail
